import { render } from "./ActivityEditor.vue?vue&type=template&id=71d0d74c&scoped=true"
import script from "./ActivityEditor.vue?vue&type=script&lang=js"
export * from "./ActivityEditor.vue?vue&type=script&lang=js"

import "./ActivityEditor.vue?vue&type=style&index=0&id=71d0d74c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d0d74c"]])

export default __exports__